import React from "react";
import { RiSmartphoneLine } from "react-icons/ri";
import { useTranslation } from "react-i18next";

const SmallDownloadApp = ({ classes }) => {
  const { i18n } = useTranslation();
  const LINK = "https://www.vkitaki.ir/fa/get-app";
  function Download() {
    window.open(LINK);
  }
  return (
    <ul
      className={
        i18n.language === "en"
          ? classes.miniContainerLtr
          : classes.miniContainer
      }
      style={{ position: "relative" }}
    >
      <li onClick={() => Download()} className={classes.menuItemHelp}>
        <RiSmartphoneLine
          className={classes.icons}
          style={{ margin: "1px", fontSize: "21px" }}
          fontSize={"small"}
        />
      </li>
    </ul>
  );
};

export default SmallDownloadApp;
